import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { VcfState } from "./types";

const initialState: VcfState = {
  isLoading: false,
};

export const vcfSlice = createSlice({
  name: "vcf",
  initialState,
  reducers: {
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
  selectors: {
    getIsLoading: (state: VcfState) => state.isLoading,
  },
});

export const { actions: vcfSliceActions, selectors: vcfSliceSelectors } = vcfSlice;
